module.exports = __webpack_public_path__ + "static/media/Bruges_20160818_4434.1af3550b.jpg";